module.exports = __webpack_public_path__ + "img/MiddleSide_Left.c570ea0d.jpg";